export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Facility/Group\",\n    \"label_plural\": \"{{count}} Facility/Group\"\n}\n"